<template>
    <div v-if="show">
       
            <v-col>
                <HeaderCheckList
                    title="Reservatórios"
                    :click="() => create()"
                />
            </v-col>
            <v-row>
                <div v-for="_reservoir, i in list">
                    <CardCheckList
                        :view="() => edit(i)"
                        :remove="() => remove(i)"
                    >
                        <template v-slot:content>
                            <div style="
                                padding: 10px;
                                width: 100%;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-around;
                            ">
                                <div>
                                    <h3 style="
                                        font-size: 15px;
                                        color: black;
                                        text-align: center;
                                    ">{{ _reservoir.locale }}</h3>
                                </div>
                                <div>
                                    <h4 style="
                                        font-size: 12px;
                                        color: black;
                                        text-align: center;
                                    ">{{ _reservoir.type }}</h4>
                                </div>
                                <div>
                                    <h5 style="
                                        font-size: 12px;
                                        color: black;
                                        text-align: center;
                                    ">{{ _reservoir.capacity }} L</h5>
                                </div>
                            </div>
                        </template>
                    </CardCheckList>
                </div>
            </v-row>
            <v-dialog transition="dialog-top-transition" v-model="dialog" persistent max-width="600px">
                <v-card>
                    <v-toolbar color="primary" dark> <span class="text-h5">Adicionar Reservatório</span></v-toolbar>
                    <v-card-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text style="padding-bottom: 0px;">
                        <v-form ref="reservoirForm" v-model="isValidForm" lazy-validation>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field 
                                        v-model="reservoir.locale" 
                                        outlined 
                                        label="Local" 
                                        type="text" 
                                        required
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field 
                                        v-model="reservoir.height" 
                                        outlined 
                                        label="Altura" 
                                        type="Number" 
                                        required
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-select 
                                        v-model="reservoir.type" 
                                        outlined 
                                        label="Reservatorio" 
                                        :items="optionsReservoir"
                                        prepend-inner-icon="mdi-cup-water" 
                                        required 
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field 
                                        v-model="reservoir.capacity" 
                                        outlined 
                                        label="Capacidade" 
                                        prefix="L" 
                                        type="Number" 
                                        required
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6" v-if="isManagementProposal">
                                    <v-select 
                                        v-model="reservoir.ifInstallation" 
                                        outlined 
                                        label="Realizar instalação?"
                                        :items="selectedIf" 
                                        required 
                                    />
                                </v-col>
                                <v-col cols="6" v-if="isManagementProposal">
                                    <v-select 
                                        v-model="reservoir.ifLoan" 
                                        outlined 
                                        label="Comodato?"
                                        :items="selectedIf" 
                                        required 
                                    />
                                </v-col>
                                <v-col cols="12" :sm="12">
                                    <v-textarea 
                                        v-model="reservoir.comments" 
                                        outlined 
                                        label="Observação" 
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                        <InputFiles
                            title="Adicionar Foto"
                            :refInput="refInput"
                            :loading="false"
                            :fileTypes="['image']"
                            :showFile="reservoir.file_photo"
                            @change:file="(file) => handleImageChange(file)"
                        />
                        <!-- <InputImg v-on:rawFiles="rawFiles = $event"/> -->
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDialog()">
                        Cancelar
                        </v-btn>
                        <v-btn :disabled="!isValidForm" color="blue darken-1" text @click="save()"> Adicionar </v-btn>
                    </v-card-actions>
                </v-card>
              </v-dialog>
    </div>
</template>
  
<script>
import HeaderCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/HeaderCheckList.vue"
import CardCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/CardCheckList.vue"
import DiagnosticStorage from '@/services/storage/DiagnosticStorage';
import InputFiles from "@/components/Forms/Input/input-files.vue";
import cloneDeep from 'lodash/cloneDeep';

import Rules from "@/utils/Rules";

const newReservoir = () => {
    return {
        locale: "",
        type: "",
        height:null,
        file_photo: null,
        path_photo: null,
        capacity: "",
        comments: "",
        ifInstallation:false,
        ifLoan:false,
    }
}

export default {
    name: "ReservoirList",
    
    components: {
        HeaderCheckList,
        CardCheckList,
        InputFiles
    },
    
    props: {
        show: {
            type: Boolean,
            default: true
        },
        list: {
            type: Array,
            default: () => ([]),
        },
        add: {
            type: Function,
            default: (hydrometer, index) => {}
        },
        remove: {
            type: Function,
            default: (index) => {}
        },
        desiredProposal: {
            type: Array,
            default: () => []
        }
    },
    
    data: () => ({
        isValidForm: true,
        refInput: new Date().getTime(),
        dialog: false,
        index: -1,
        reservoir: newReservoir(),
        optionsReservoir: ["Superior", "Inferior", "Caixa d'água"],
        selectedIf:[
            {text:"Sim", value:true},
            {text:"Não", value:false},
        ],
    }),
    
    computed: {
        rulesRequired() {
            return Rules.required();
        },
        isManagementProposal(){
            return this.desiredProposal.includes("management")
        },
    },

    methods: {
        create() {
            this.index = -1
            this.reservoir = newReservoir()
            this.refInput = new Date().getTime()
            this.dialog = true
        },
        handleImageChange(file) {
            if (!file) {
                this.reservoir.path_photo = null;
                this.reservoir.file_photo = null;
            } else {
                this.reservoir.path_photo = null;
                this.reservoir.file_photo = file;
            }
        },
        clearImageState() {
            if (this.reservoir) {
                this.reservoir.file_photo = null
                this.reservoir.path_photo = null
            }
        },
        async edit(index) {
            this.index = index
            this.reservoir = cloneDeep(this.list[index])
            
            this.refInput = new Date().getTime()
            
            if (this.reservoir.path_photo) {
                try {
                    this.reservoir.file_photo = await DiagnosticStorage.downloadImg(this.reservoir.path_photo)
                } catch (error) {
                    console.error('Erro ao carregar imagem:', error)
                    this.reservoir.file_photo = null
                }
            }
            
            await this.$nextTick()
            this.dialog = true
        },
        save() {
            if (!this.$refs.reservoirForm.validate()) return
            this.add(cloneDeep(this.reservoir), this.index)
            this.dialog = false
            this.clearImageState()
        },
        closeDialog() {
            this.dialog = false
            this.clearImageState()
            if (this.reservoir && this.reservoir.file_photo) {
                this.reservoir.file_photo = null
            }
        },
    },

    watch: {
        
    },

};
</script>
  
<style scoped>

</style>